/**
 * Class with the content to popup to Geocode
 */

const { stopDetailsButtons, stopDetailsGeocodeStop, stopDetailsPopup } = window.actions;

Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.PopupToGeocode = function (routeId, marker, stopId) {

    var map = Monet.Session.RouteDetail.screensList[routeId].map;

    this.renderGeocode = function () {

        const geocode = new Greenmile.RouteDetail.GeocodeStop(routeId, map);
        const textToIcon = Monet.Session.RouteDetail.screensList[routeId].editingStop.marker.options.icon.options.content;
        const stop = Monet.Session.RouteDetail.screensList[routeId].editingStop.stop;
        const feasibleLat = stop.latitude || stop.location.latitude;
        const feasibleLng = stop.longitude || stop.location.longitude;
        
        geocode.setStop(stop).removeGeocodedPosition().setCorrectLocation(this.positionToSave.latitude, this.positionToSave.longitude);
        geocode.createMarker(textToIcon).addTo(map);
        geocode.drawPolyline([feasibleLat, feasibleLng], [this.positionToSave.latitude, this.positionToSave.longitude]);
    };

    this.clickActionToCancel;
    this.rootEl;
    this.positionToSave;
    this.callbackToSaveAndReprocess;

    this.setCallbackToSaveAndReprocess = function (fn) {
        this.callbackToSaveAndReprocess = fn;
    };

    this.setPositionToSave = function (positionToSave) {
        this.positionToSave = positionToSave;
        return this;
    };

    this.afterActions = function () {
        marker.closePopup();
        App.Views.RouteDetails.removeGeocodeSuggest(routeId);
        Greenmile.Map.Utility.removeLayerByKind(map, ['STOP_SUGGESTIONS']);
        Monet.Session.RouteDetail.screensList[routeId].isUpdateAutomatic = true;
        Monet.Session.RouteDetail.screensList[routeId].editingStop = null;
    };

    this.clickActionToSave = function () {
        this.showLoading();
        this.savePositionLatLng(function (context) {
            return function () {
                context.renderGeocode();
                context.afterActions();
                window.GreenmileReduxStore.dispatch(stopDetailsPopup.saveGeocode(routeId, stopId));
            };
        }(this));
    };

    this.clickActionToCancel = function () {
        this.afterActions();
        window.GreenmileReduxStore.dispatch(stopDetailsPopup.disableGeocode(routeId, stopId));
        
    };

    this.getAutoArriveConfigurationAndRenderPopupInfoToReprocess = function () {
        var autoArriveConfiguration = new App.Collections.AutoArriveConfigurations();
        var criteria = {
            'criteriaChain': [{
                'and': [{
                    'attr': 'organization.id',
                    'eq': Monet.Session.RouteDetail.screensList[routeId].model.organization.id
                }]
            }]
        };

        autoArriveConfiguration.filterWithRestrictions({
            criteria: JSON.stringify({ "filters": ["defaultLocationRadius", "numberSecondsToGuessArrival", "cancelCode.*"] }),
            filter: criteria,
            success: function (autoArriveConfigurationCollection) {
                var autoArriveConfiguration = [];
                if (autoArriveConfigurationCollection.size()) {
                    autoArriveConfiguration = autoArriveConfigurationCollection.first().attributes;
                }
                marker.unbindPopup().bindPopup(new Greenmile.RouteDetail.PopupInfoToReprocess(routeId, marker, autoArriveConfiguration).render(), {
                    offset: new L.Point(48, 2),
                    className: 'geocode-popup',
                    maxWidth: 600,
                    closeButton: false
                }).openPopup();

            }
        });
    };

    this.clickActionToSaveAndReprocess = function () {

        App.Views.RouteDetails.removeGeocodeSuggest(routeId);
        this.showLoading();
        this.savePositionLatLng(function (context) {
            return function () {
                if (context.callbackToSaveAndReprocess) {
                    context.callbackToSaveAndReprocess();
                }
                window.GreenmileReduxStore.dispatch(stopDetailsPopup.saveGeocode(routeId, stopId));
            };
        }(this));
    };

    this.setClickActionToCancel = function (clickActionToCancel) {
        this.clickActionToCancel = clickActionToCancel;
    };

    this.savePositionLatLng = function (callbackSuccess) {

        var id = Monet.Session.RouteDetail.screensList[routeId].editingStop.stop.location.id;
        var ajax = new Monet.Ajax();
        ajax.url = 'Location/' + id + "/UpdatePosition";
        ajax.data = this.positionToSave;
        ajax.method = "POST";

        ajax.success = function () {
            if (callbackSuccess) {
                callbackSuccess();
            }
        };

        ajax.send();

    };

    this.getDistanceBetweenLatLng = function (beginPosition, endPosition) {

        var distance = new Monet.Format.DISTANCE(L.latLng(beginPosition).distanceTo(endPosition)).toGrid().getValue();
        var distanceStr = "<strong>" +
            Monet.I18n.getResourcesByKey("RouteDetail.ToolBar.pointsToDistance.total") +
            ":</strong> ";

        distanceStr += distance + "<br />";

        return distanceStr;

    };

    this.createButton = function () {

        var btnContainer = document.createElement('div');
        var buttonSave = new Monet.UI.Fields.Button();
        var buttonCancel = new Monet.UI.Fields.Button();
        var buttonReprocessAutoArrive = new Monet.UI.Fields.Button();

        btnContainer.className = 'internPopupBtn';

        buttonSave.setInputId('btnSave');
        buttonSave.setValue(Monet.I18n.getResourcesByKey('default.button.save'));
        buttonSave.addEventClickListener(function (context) {
            return function () {
                context.clickActionToSave();
            };
        }(this));

        buttonReprocessAutoArrive.setInputId('btnReprocessAutoArrive');
        buttonReprocessAutoArrive.setValue(Monet.I18n.getResourcesByKey('RouteDetail.Geocode.btnReprocessAutoArrive'));
        buttonReprocessAutoArrive.addEventClickListener(function (context) {
            return function () {
                context.clickActionToSaveAndReprocess();
            };
        }(this));

        buttonCancel.setInputId('btnCancel');
        buttonCancel.setValue(Monet.I18n.getResourcesByKey('default.button.cancel'));
        buttonCancel.addEventClickListener(function (context) {
            return function () {
                context.clickActionToCancel();
            };
        }(this));

        btnContainer.appendChild(buttonCancel.render());
        btnContainer.appendChild(buttonReprocessAutoArrive.render());
        btnContainer.appendChild(buttonSave.render());

        return btnContainer;

    };

    this.showLoading = function () {

        var loading = this.rootEl.querySelector('img');
        var form = this.rootEl.querySelector('.askNewPositionStop');

        form.style.display = 'none';
        loading.style.display = 'block';

    };

    this.render = function (beginPosition, endPosition) {

        var container    = document.createElement('div'),
            loading      = document.createElement('img'),
            popupDiv     = document.createElement('div'),
            textAsk      = document.createElement('div'),
            textDistance = document.createElement('div'),
            btns         = this.createButton();

        popupDiv.className = 'askNewPositionStop';

        textAsk.className = 'containerQuestion';
        textAsk.innerHTML = Monet.I18n.getResourcesByKey('want.to.save.position');
        loading.className = 'loading';
        loading.src = require("static/images/general/loading_blue.svg");

        textDistance.className = 'containerDistance';
        textDistance.innerHTML = this.getDistanceBetweenLatLng(beginPosition, endPosition);

        popupDiv.appendChild(textAsk);
        popupDiv.appendChild(textDistance);
        popupDiv.appendChild(btns);
        container.appendChild(loading);
        container.appendChild(popupDiv);

        this.rootEl = container;

        return this.rootEl;

    };

};
